import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { Lock } from "lucide-react";
import { AI_INSIGHTS_TOOL_SLUG, LockedStateProps } from "../../domain/types";

/**
 * Shared locked state for every AI Insights surface (issue #189).
 *
 * Rendered instead of an AI panel when the therapist has not adopted the tool,
 * with a link to the marketplace detail page so adoption is one click away.
 */
const LockedState: React.FC<LockedStateProps> = ({ title, description, className, compact }) => {
    const { t } = useTranslation();

    return (
        <div
            role="status"
            aria-live="polite"
            className={`bg-white rounded-2xl shadow-sm border border-gray-100 text-center ${compact ? "p-4" : "p-6"} ${className || ""}`}
        >
            <div className="w-12 h-12 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <Lock className="w-6 h-6 text-content-tertiary" aria-hidden="true" />
            </div>
            <h4 className="text-sm font-bold text-gray-900 mb-2">{title}</h4>
            <p className="text-xs text-gray-500 mb-4 px-2">
                {description || t("aiInsights.locked.description")}
            </p>
            <Link
                to={`/tools-catalog/${AI_INSIGHTS_TOOL_SLUG}`}
                className="inline-flex items-center justify-center min-h-[44px] px-4 text-xs font-medium rounded-lg ai-spectrum-fill focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-500"
            >
                {t("aiInsights.locked.cta")}
            </Link>
        </div>
    );
};

export default LockedState;
